import { ErrorBase } from '@/errors/ErrorBase';

export class DisabledStatusError extends ErrorBase {
    static get defaultMessage(): string {
        return 'ご利用のアカウントは有効ではないため、ログインすることができません。';
    }

    static get errorName(): string {
        return 'DisabledStatusError';
    }
}
